{
    "Accessibility menu": "Erişilebilirlik Menüsü",
    "Close": "Kapat",
    "Content adjustments": "İçerik Ayarları",
    "Navigation adjustments": "Gezinme Ayarları",
    "Text Align": "Metin Hizalama",
    "Align Left": "Sola Hizala",
    "Align Center": "Ortala",
    "Align Right": "Sağa Hizala",
    "Adjust Font Size": "Yazı Tipi Boyutunu Ayarla",
    "Highlight Title": "Başlığı Vurgula",
    "Highlight Links": "Bağlantıları Vurgula",
    "Readable Font": "Okunaklı Yazı Tipi",
    "Colour adjustments": "Renk Ayarları",
    "Dark Contrast": "Koyu Kontrast",
    "Light Contrast": "Açık Kontrast",
    "High Contrast": "Yüksek Kontrast",
    "High Saturation": "Yüksek Doygunluk",
    "Low Saturation": "Düşük Doygunluk",
    "Monochrome": "Tek Renkli",
    "Tools": "Araçlar",
    "Reading Guide": "Okuma Rehberi",
    "Big Cursor": "Büyük İmleç",
    "Increase Font Size": "Yazı Tipi Boyutunu Artır",
    "Decrease Font Size": "Yazı Tipi Boyutunu Azalt",
    "Letter Spacing": "Harf Aralığı",
    "Line Height": "Satır Yüksekliği",
    "Font Weight": "Yazı Tipi Kalınlığı",
    "Dyslexia Font": "Disleksi Yazı Tipi",
    "Language": "Dil",
    "Accessibility widget": "Erişilebilirlik menüsünü aç",
    "Accessibility Profiles": "Erişilebilirlik Profilleri",
    "Cognitive Disability": "Bilişsel Engellilik",
    "Seizure Safe": "Nöbet Güvenli",
    "Accessibility statement": "Erişilebilirlik Beyanı",
    "ADHD": "DEHB",
    "Low Vision": "Az Görme",
    "Pause Animations": "Animasyonları Durdur",
    "Animation paused": "Animasyon duraklatıldı",
    "Reset all settings": "Ayarları Sıfırla",
    "Shortcut:": "Kısayol:",
    "Epilepsy Safe Mode": "Epilepsi Güvenli Modu",
    "Mute sounds": "Sesleri kapat",
    "Page read": "Sayfa okuma",
    "Page read controls": "Sayfa okuma kontrolleri",
    "Pause": "Duraklat",
    "Resume": "Devam et",
    "Stop": "Durdur",
    "Settings": "Ayarlar",
    "Speed": "Hız",
    "Voice": "Ses",
    "Close accessibility menu": "Erişilebilirlik menüsünü kapat",
    "Back to accessibility menu": "Erişilebilirlik menüsüne dön",
    "Search languages": "Dilleri ara",
    "Selected language": "Seçili dil",
    "View accessibility statement (opens in new window)": "Erişilebilirlik bildirimini görüntüle (yeni pencerede açılır)",
    "Visit CookieYes website (opens in new window)": "CookieYes web sitesini ziyaret et (yeni pencerede açılır)",
    "Reset all accessibility settings to default": "Tüm erişilebilirlik ayarlarını varsayılana sıfırla"
}
